// import { useQuickCallModal } from "@/hooks/useQuickCallModal";
import {
  Button,
  ColorIcon,
  colors,
  customEvent,
  GLOBAL_MAX_WIDTH,
  HStack,
  useResponsive,
  VStack,
} from "goi_common";
import { useGoiCall } from "@/hooks/useGoiCall";

export default function FacilitiesCallFixedButtons({
  solo,
  maxWidth,
  bottom,
  onlyDesktop,
}: {
  solo?: boolean;
  maxWidth?: string;
  bottom?: {
    sm?: string;
    md?: string;
    lg?: string;
  };
  onlyDesktop?: boolean;
}) {
  const { isBiggerThanLg, setResponsive } = useResponsive();
  const { goiCall } = useGoiCall();

  const onClickLeftButton = () => {
    customEvent({
      newGtm: {
        path: "snackbar",
        trigger_and_target: "ftr_btn_lft-opn_mdl",
      },
    });
    goiCall();
  };

  // const { onQuickCallModal } = useQuickCallModal();

  const onClickRightButton = () => {
    //call("1666-9784");
    goiCall({ showFacilityModal: true });
    customEvent({
      newGtm: {
        path: "snackbar",
        trigger_and_target: "ftr_btn_rght-opn_mdl",
      },
      triggerHackle: true,
    });

    // onQuickCallModal();
  };

  return (
    <>
      <VStack
        maxWidth={`${maxWidth}px`}
        width="100%"
        margin="auto"
        css={{
          position: "fixed",
          bottom: setResponsive(bottom?.sm || "16px", bottom?.md || "20px", "0px"),
          padding: setResponsive("0px 10px", "0 20px", "0px"),
        }}
        alignItems={maxWidth ? "center" : "flex-end"}
        zIndex={1040}
      >
        {isBiggerThanLg ? (
          <HStack width="100%" height="80px" background="black" justifyContent="center">
            <HStack
              maxWidth={GLOBAL_MAX_WIDTH}
              width="100%"
              alignItems="center"
              justifyContent={"flex-end"}
              margin="0px 24px"
              gap={16}
            >
              <Button
                className="button_16_sb"
                css={{
                  color: "white",
                  background: colors.orange650,
                  width: "240px",
                  height: "50px",
                  borderRadius: "5px",
                }}
                onClick={onClickLeftButton}
              >
                24시간 임종 상담
              </Button>

              {!solo && (
                <Button
                  className="button_16_sb"
                  css={{
                    color: "white",
                    background: colors.orange650,
                    width: "240px",
                    height: "50px",
                    borderRadius: "5px",
                  }}
                  onClick={onClickRightButton}
                >
                  빠른 상담
                </Button>
              )}
            </HStack>
          </HStack>
        ) : (
          <>
            {onlyDesktop || (
              <HStack width="100%" maxWidth={maxWidth || "100%"} height="48px" gap={10}>
                <Button
                  style={{
                    width: "100%",
                    background: "black",
                    borderRadius: "5px",
                    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                  }}
                  onClick={onClickLeftButton}
                >
                  <HStack alignItems="center" justifyContent="center" gap={8}>
                    <div className="button_14_sb white">24시간 임종 상담</div>
                    <ColorIcon name="icon-arrow-right-small-mono" size={16} color="white" />
                  </HStack>
                </Button>
                {!solo && (
                  <Button
                    style={{
                      width: "100%",
                      background: "black",
                      borderRadius: "5px",
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                    }}
                    onClick={onClickRightButton}
                  >
                    <HStack alignItems="center" justifyContent="center" gap={8}>
                      <div className="button_14_sb white">빠른 상담</div>
                      <ColorIcon name="icon-arrow-right-small-mono" size={16} color="white" />
                    </HStack>
                  </Button>
                )}
              </HStack>
            )}
          </>
        )}
      </VStack>
    </>
  );
}
